module.exports = __webpack_public_path__ + "static/media/check.c941eb70.svg";